import GoogleClassroomIcon from '@/assets/icons/google-classroom.svg?react';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { Box, IconButton, ListItemIcon, Menu, MenuItem, SvgIcon, Tooltip, Typography } from '@mui/material';
import { PageHeader, PageHeaderToolbar } from '@toolpad/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

type PageHeaderToolbarProps = {
    disabled?: boolean;
    tooltip?: string;
    onBulkCreate?: () => void;
    onCreate?: () => void;
    onImportGoogleClassroom?: () => void;
};

function ImportMenu({ anchor, onClose, onImportGoogleClassroom }: { anchor: HTMLElement | null; onClose: () => void; onImportGoogleClassroom?: () => void }) {
    return (
        <Menu
            anchorEl={anchor}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            open={Boolean(anchor)}
            onClose={onClose}
        >
            <MenuItem onClick={onImportGoogleClassroom}>
                <ListItemIcon>
                    <SvgIcon component={GoogleClassroomIcon} inheritViewBox fontSize='small' />
                </ListItemIcon>
                {/* Google Classroom as a brand has no translation */}
                <Typography sx={{ textAlign: 'center' }}>Google Classroom</Typography>
            </MenuItem>
        </Menu>
    );
}

export function StudentPageToolbar(props: PageHeaderToolbarProps) {
    const { t } = useTranslation();
    const [anchorElImport, setAnchorElImport] = React.useState<null | HTMLElement>(null);

    const handleOpenImportMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElImport(event.currentTarget);
    };

    const handleCloseImportMenu = () => {
        setAnchorElImport(null);
    };

    return (
        <PageHeaderToolbar>
            <Box>
                <Tooltip title={props.tooltip} arrow placement='left'>
                    <Box sx={{ gap: 1, display: 'flex' }}>
                        <Tooltip title={t('common.import')}>
                            <div>
                                <IconButton onClick={handleOpenImportMenu} disabled={props.disabled}>
                                    <ImportExportIcon />
                                </IconButton>
                            </div>
                        </Tooltip>
                        <Tooltip title={t('student.button.bulkCreate')}>
                            <div>
                                <IconButton onClick={props.onBulkCreate} disabled={props.disabled}>
                                    <GroupAddIcon />
                                </IconButton>
                            </div>
                        </Tooltip>
                        <Tooltip title={t('common.create')}>
                            <div>
                                <IconButton onClick={props.onCreate} disabled={props.disabled}>
                                    <PersonAddAlt1Icon />
                                </IconButton>
                            </div>
                        </Tooltip>
                    </Box>
                </Tooltip>
            </Box>
            <ImportMenu anchor={anchorElImport} onClose={handleCloseImportMenu} onImportGoogleClassroom={props.onImportGoogleClassroom} />
        </PageHeaderToolbar>
    );
}

export function StudentPageHeader(props: PageHeaderToolbarProps) {
    const StudentPageToolbarComponent = React.useCallback(() => <StudentPageToolbar {...props} />, [props]);
    return <PageHeader slots={{ toolbar: StudentPageToolbarComponent }} breadcrumbs={[]} />;
}
